export default __webpack_public_path__ + "static/media/(8).10a7f8f8.jpg";